import { noop } from 'lodash';
import { createContext } from 'react';

export const ModalContext = createContext({ open: false, setOpen: noop });
